"use client";

import React from "react";
import Table, { Column } from "../ui/Table";

interface ZeroDayData {
  id: string;
  date: string;
  product: string;
  versions: string;
  type: string;
  severity: "critical" | "high" | "medium" | "low";
  status: "Killed" | "Active";
  details: {
    vendor: string;
    platform: string;
    cvssScore: string;
    patch: string;
    summary: string;
    credits: string;
  };
}

const ZeroDayTracker = () => {
  const data: ZeroDayData[] = [
    {
      id: "64",
      date: "2026",
      product: "PDF Architect 9",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "pdfforge",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "63",
      date: "2026",
      product: "HP Office Jet Pro 9020 series",
      versions: "Current",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "HP",
        platform: "Embedded Device",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "0xakm",
      },
    },
    {
      id: "62",
      date: "2026",
      product: "360 Total Security",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "Qihoo 360",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "jin1337",
      },
    },
    {
      id: "61",
      date: "2026",
      product: "Avast One",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "Avast",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "jin1337",
      },
    },
    {
      id: "60",
      date: "2026",
      product: "AWS VPN Client",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "AWS",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "z22 | qbao",
      },
    },
    {
      id: "59",
      date: "2026",
      product: "Foxit Reader",
      versions: "2026.*",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "Foxit",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "qbao | cobra",
      },
    },
    {
      id: "58",
      date: "2026",
      product: "Typora",
      versions: "Current",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "Typora",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "57",
      date: "2025",
      product: "Checkpoint VPN",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "Checkpoint",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "56",
      date: "2025",
      product: "Foxit Reader",
      versions: "2025-2026",
      type: "Local Privlege Escalation",
      severity: "high",
      status: "Active",
      details: {
        vendor: "Foxit",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "55",
      date: "2024",
      product: "Nitro PDF",
      versions: "Current",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "Nitro",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "54",
      date: "2024",
      product: "Foxit Reader",
      versions: "2024.*",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Foxit",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "z22 | qbao",
      },
    },
    {
      id: "53",
      date: "2024",
      product: "RocketChat",
      versions: "Current",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "RocketChat",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "52",
      date: "2024",
      product: "BitDefender Safepay",
      versions: "Current",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Active",
      details: {
        vendor: "BitDefender",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "cobra",
      },
    },
    {
      id: "51",
      date: "2023",
      product: "Softing edgeConnector",
      versions: "Current",
      type: "Denial-of-Service",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Siemens",
        platform: "",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "hayicle | cobra",
      },
    },
    {
      id: "50",
      date: "2023",
      product: "Triangle Works",
      versions: "Current",
      type: "Pre-auth Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Microworks",
        platform: "",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "bibo | hayicle | ahihi",
      },
    },
    {
      id: "49",
      date: "2023",
      product: "Firefox / TOR Browser RCE",
      versions: "Current",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Mozilla",
        platform: "Firefox",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "N/A",
      },
    },
    {
      id: "48",
      date: "2022",
      product: "Windows LPE #3",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Microsoft",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "N/A",
      },
    },
    {
      id: "47",
      date: "2022",
      product: "Windows LPE #2",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Microsoft",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "N/A",
      },
    },
    {
      id: "46",
      date: "2022",
      product: "Windows LPE",
      versions: "Current",
      type: "Local Privlege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Microsoft",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "N/A",
      },
    },
    {
      id: "45",
      date: "2021",
      product: "Yandex",
      versions: "Current",
      type: "Theft of Sensitive Data",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Yandex",
        platform: "Android",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "z22",
      },
    },
    {
      id: "44",
      date: "2021",
      product: "Yandex Browser",
      versions: "Current",
      type: "Theft of Sensitive Data",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Yandex",
        platform: "Android",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "z22",
      },
    },
    {
      id: "43",
      date: "2021",
      product: "ADManager Plus",
      versions: "Current",
      type: "Code Execution #15",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "42",
      date: "2021",
      product: "ADManager Plus",
      versions: "Current",
      type: "Code Execution #14",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "41",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #13",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "40",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Authentication Bypass",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "hayicle",
      },
    },
    {
      id: "39",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #12",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "m3",
      },
    },
    {
      id: "38",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #11",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "m3",
      },
    },
    {
      id: "37",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #10",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "m3",
      },
    },
    {
      id: "36",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #9",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "m3",
      },
    },
    {
      id: "35",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #8",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "m3",
      },
    },
    {
      id: "34",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #7",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "qbao",
      },
    },
    {
      id: "33",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #6",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "ncd",
      },
    },
    {
      id: "32",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #5",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "ncd",
      },
    },
    {
      id: "31",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #4",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "ncd",
      },
    },
    {
      id: "30",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #3",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "ncd",
      },
    },
    {
      id: "29",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #2",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "no3g",
      },
    },
    {
      id: "28",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Code Execution #1",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "z22",
      },
    },
    {
      id: "27",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Pre-auth Code Execution #3",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "26",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Pre-auth Code Execution #2",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "25",
      date: "2021",
      product: "ADManager Plus",
      versions: "< 7111",
      type: "Pre-auth Code Execution #1",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Manage Engine",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "bmtd",
      },
    },
    {
      id: "24",
      date: "2021",
      product: "V-Key App Protection",
      versions: "Current",
      type: "Security Bypass",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "V-Key",
        platform: "IOS",
        cvssScore: "",
        patch: "",
        summary: "",
        credits: "hayicle | bmtd",
      },
    },
    {
      id: "23",
      date: "2019",
      product: "McAfee Total Protection",
      versions: "16",
      type: "Privilege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "McAfee",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "22",
      date: "2017",
      product: "MalwareBytes",
      versions: "3.0.4 - 3.2.x",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Malwarebytes",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "21",
      date: "2017",
      product: "Firefox Quantum",
      versions: "< 58",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Mozilla",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "20",
      date: "2017",
      product: "7z",
      versions: "> 16",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "7z",
        platform: "Windows / Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "19",
      date: "2017",
      product: "PeaZip",
      versions: "> 6.4",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "18",
      date: "2017",
      product: "PowerArchiver",
      versions: "> 16.1",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "ConeXware",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "pdnx00 | nixspl0it",
      },
    },
    {
      id: "17",
      date: "2016",
      product: "Internet Explorer",
      versions: "< 11",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Microsoft",
        platform: "Windows",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "nixspl0it",
      },
    },
    {
      id: "16",
      date: "2015",
      product: "Open WebMail",
      versions: "2.52",
      type: "Local File Inclusion",
      severity: "medium",
      status: "Killed",
      details: {
        vendor: "Open WebMail",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "xelenonz",
      },
    },
    {
      id: "15",
      date: "2015",
      product: "Open WebMail",
      versions: "2.52",
      type: "Remote Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Open WebMail",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "xelenonz",
      },
    },
    {
      id: "14",
      date: "2015",
      product: "Open WebMail",
      versions: "2.52",
      type: "Privilege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Open WebMail",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "xelenonz",
      },
    },
    {
      id: "13",
      date: "2015",
      product: "McAfee Agent EPO",
      versions: "N/A",
      type: "Arbitrary File Reading",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "McAfee",
        platform: "Windows",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "12",
      date: "2013",
      product: "Freewill Gold Trading",
      versions: "N/A",
      type: "Privilege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Freewill",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "11",
      date: "2013",
      product: "Freewill Gold Trading",
      versions: "N/A",
      type: "Code Injection",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Freewill",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "xelenonz",
      },
    },
    {
      id: "10",
      date: "2013",
      product: "SabreAMF",
      versions: "1.4",
      type: "XML External Entity",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Rooftop",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "xelenonz",
      },
    },
    {
      id: "9",
      date: "2009",
      product: "CPanel",
      versions: "11.24.5-RELEASE",
      type: "Arbitrary File Viewing",
      severity: "medium",
      status: "Killed",
      details: {
        vendor: "cPanel",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "8",
      date: "2009",
      product: "CPanel",
      versions: "11.24.5-RELEASE",
      type: "Privilege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "cPanel",
        platform: "Linux",
        cvssScore: "",
        patch: "No",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "7",
      date: "2009",
      product: "CPanel",
      versions: "11.24.5-RELEASE",
      type: "Root Privilege Escalation",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "cPanel",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "6",
      date: "2008",
      product: "Belkin Router",
      versions: "F5D8233-4 V3, firmware 3.01.29",
      type: "Admin Remote Access",
      severity: "high",
      status: "Killed",
      details: {
        vendor: "Belkin",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "5",
      date: "2007",
      product: "PHP Groupware",
      versions: "N/A",
      type: "Code Injection",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Portico Estate",
        platform: "Windows / Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "4",
      date: "2006",
      product: "D-Link/Cipherium Interet Hotspot (Embedded System)",
      versions: "Bonalinx W-1300, firmware 1.5",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "D-link",
        platform: "Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "3",
      date: "2005",
      product: "Sawmill Log Analyzer",
      versions: "7.0.X, < 7.1.7",
      type: "Arbitrary File Viewing",
      severity: "medium",
      status: "Killed",
      details: {
        vendor: "Sawmill",
        platform: "Windows / Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "2",
      date: "2005",
      product: "Sawmill Log Analyzer",
      versions: "7.0.X, < 7.1.6",
      type: "Arbitrary Directory Browsing",
      severity: "medium",
      status: "Killed",
      details: {
        vendor: "Sawmill",
        platform: "Windows / Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
    {
      id: "1",
      date: "2005",
      product: "Sawmill Log Analyzer",
      versions: "7.0.X, < 7.1.6",
      type: "Code Execution",
      severity: "critical",
      status: "Killed",
      details: {
        vendor: "Sawmill",
        platform: "Windows / Linux",
        cvssScore: "",
        patch: "Yes",
        summary: "",
        credits: "pdnx00",
      },
    },
  ];

  const columns: Record<string, Column<ZeroDayData>> = {
    date: {
      id: "date",
      name: "Date",
      show: true,
      width: 145,
      render: (rowData: ZeroDayData) => <span>{rowData.date}</span>,
    },
    product: {
      id: "product",
      name: "Product",
      show: true,
    },
    versions: {
      id: "versions",
      name: "Versions",
      show: true,
      width: 177,
    },
    type: {
      id: "type",
      name: "Type",
      show: true,
      width: 270,
    },
    severity: {
      id: "severity",
      name: "Severity",
      show: true,
      width: 130,
      align: "center" as const,
      render: (rowData: ZeroDayData) => {
        const colorClass =
          rowData.severity === "critical"
            ? "text-[#EC1938]"
            : rowData.severity === "high"
            ? "text-[#FFBC3B]"
            : rowData.severity === "medium"
            ? "text-[#3EAFF0]"
            : "text-[#00C7CD]";
        return (
          <span
            className={`font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] capitalize ${colorClass}`}
          >
            {rowData.severity.charAt(0).toUpperCase() + rowData.severity.slice(1)}
          </span>
        );
      },
    },
    status: {
      id: "status",
      name: "Status",
      show: true,
      width: 198,
      align: "center" as const,
      render: (rowData: ZeroDayData) => (
        <span
          className={`font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] ${
            rowData.status === "Killed" ? "text-[#00C7CD]" : "text-[#EC1938]"
          }`}
        >
          {rowData.status}
        </span>
      ),
      collapseContent: (rowData: ZeroDayData) => (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 py-2">
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              Vendor:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.vendor || "-"}
            </span>
          </div>
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              Patch:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.patch || "-"}
            </span>
          </div>
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              Platform:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.platform || "-"}
            </span>
          </div>
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              Summary:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.summary || "-"}
            </span>
          </div>
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              CVSS Score:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.cvssScore || "-"}
            </span>
          </div>
          <div className="flex gap-4">
            <span className="text-primary font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px] min-w-[100px]">
              Credits:
            </span>
            <span className="text-white font-normal text-[14px] sm:text-[16px] leading-[24px] sm:leading-[28px] tracking-[0.5px]">
              {rowData.details.credits || "-"}
            </span>
          </div>
        </div>
      ),
    },
  };

  return (
    <div className="relative w-full px-4 sm:px-6 lg:px-8 pt-2 pb-12 overflow-hidden">
      <div className="max-w-[1300px] mx-auto relative z-10">
        {/* Description Section */}
        <div className="mb-12 max-w-[644px] space-y-6 sm:space-y-7">
            <p className="body-1 text-text-default">
              Zero-Day Tracker is built to help you understand a fully patched
              system and application cannot guarantee security. All the
              vulnerabilities listed below are the results of our researches and
              they have not been disclosed to the vendors or public. Though in the
              past we have clearly supported responsible disclosure of security
              vulnerability, now we no longer endorse it.
            </p>
            <p className="body-1 text-text-default">
              While we are trying to keep the information as accurate as possible,
              we cannot guarantee that these vulnerabilities are indeed zero-day
              since it is a known fact that they may have been circled around
              among the hackers for a long time.
            </p>
            <p className="body-1 text-text-default">
              The list below covers some of the vulnerabilities that we have in
              our lab and this list will be updated when we see fit.
            </p>
        </div>

        {/* Table */}
        <Table
          columns={columns}
          data={data}
          enableCollapse={true}
          customClassName=""
        />
      </div>
    </div>
  );
};

export default ZeroDayTracker;
